'use client';

import type { InactivityEventData } from '@hc-frontend/third-party-snowplow';
import { trackInactivity } from '@hc-frontend/third-party-snowplow';
import type { IIdleTimerProps } from 'react-idle-timer';
import { useIdleTimer } from 'react-idle-timer';

const ONE_MINUTE = 1000 * 60;

// Using fibonacci sequence for threshold values.
const THRESHOLD_1 = ONE_MINUTE * 3;
const THRESHOLD_2 = ONE_MINUTE * 5;
const THRESHOLD_3 = ONE_MINUTE * 8;
const THRESHOLD_4 = ONE_MINUTE * 13;
const THRESHOLD_5 = ONE_MINUTE * 21;

const commonProps: Partial<IIdleTimerProps> = {
  eventsThrottle: 1000 * 30, // 30 seconds
};

export function InactivityTracker(
  props: Omit<InactivityEventData, 'totalTime'>,
) {
  const track = (totalTime: number) => {
    trackInactivity({
      ...props,
      totalTime,
    });
  };

  useIdleTimer({
    ...commonProps,
    name: 'inactivity-threshold-1',
    onIdle: () => track(THRESHOLD_1),
    timeout: THRESHOLD_1,
  });

  useIdleTimer({
    ...commonProps,
    name: 'inactivity-threshold-2',
    onIdle: () => track(THRESHOLD_2),
    timeout: THRESHOLD_2,
  });

  useIdleTimer({
    ...commonProps,
    name: 'inactivity-threshold-3',
    onIdle: () => track(THRESHOLD_3),
    timeout: THRESHOLD_3,
  });

  useIdleTimer({
    ...commonProps,
    name: 'inactivity-threshold-4',
    onIdle: () => track(THRESHOLD_4),
    timeout: THRESHOLD_4,
  });

  useIdleTimer({
    ...commonProps,
    name: 'inactivity-threshold-5',
    onIdle: () => track(THRESHOLD_5),
    timeout: THRESHOLD_5,
  });

  return null;
}
